// Footer.js

import React, { useEffect, useRef } from "react";
import logo from "../assets/bt4mlogo.png";
import { FaPhoneAlt } from "react-icons/fa";

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const el = footerRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("footer-visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    if (el) {
      observer.observe(el);

      // FIX FOR SHORT PAGES (footer visible at load)
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add("footer-visible");
      }
    }
  }, []);

  return (
    <footer
      ref={footerRef}
      className="
        footer-hidden
        bg-gradient-to-b from-[#0F172A] to-[#1E293B]
        text-white pt-14 pb-8 px-4 sm:px-10
        shadow-inner
      "
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

        {/* BRAND */}
        <div>
          <center>
            <img
              src={logo}
              alt="BookTrip4Me Logo"
              className="h-24 w-24 mb-4 shadow-lg object-contain"
            />
          </center>
          <h2 className="text-xl font-semibold mb-3 text-teal-300">BookTrip4Me</h2>
          <p className="text-sm text-gray-300 leading-relaxed">
            Your trusted travel partner—find the best deals on flights, hotels,
            and dream vacations with a touch of modern simplicity.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-300">Quick Links</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><a href="/mission" className="hover:text-white transition">About Us</a></li>
            <li><a href="/cruises" className="hover:text-white transition">Contact Us</a></li>
          </ul>
        </div>

        {/* SUPPORT */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-300">Support</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><a href="/termsandconditions" className="hover:text-white transition">Terms & Conditions</a></li>
            <li><a href="/policy" className="hover:text-white transition">Privacy Policy</a></li>
            <li><a href="/faq" className="hover:text-white transition">FAQs</a></li>
            <li><a href="/cruises" className="hover:text-white transition">Customer Support</a></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-teal-300">Contact Information</h3>

          <p className="text-sm text-gray-300 mb-4">
            Email: support@BookTrip4Me.com
          </p>

          <a
            href="tel:+18887112909"
            className="
              flex items-center justify-center gap-2
              px-5 py-3 rounded-xl
              bg-gradient-to-r from-red-600 to-red-500
              hover:from-green-600 hover:to-green-500
              text-white font-semibold
              transition-all duration-300
              shadow-lg hover:shadow-xl
            "
          >
            <FaPhoneAlt className="text-lg" />
            +1 888-711-2909
          </a>

          <div className="flex mt-5 space-x-5 text-xl text-gray-400">
            <a href="#" className="hover:text-white transition"><i className="fab fa-facebook"></i></a>
            <a href="#" className="hover:text-white transition"><i className="fab fa-instagram"></i></a>
            <a href="#" className="hover:text-white transition"><i className="fab fa-twitter"></i></a>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700 mt-10 pt-5 text-center text-xs text-gray-400">
        © 2025 BookTrip4Me. A travel service by BookTrip4Me, LLC. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
